import React, { useEffect, useState } from 'react';
import { CardLoader, InfoCard } from 'components';
import { useServerDataStatus, useServerStatus } from 'hooks';
import { Grid } from '@mui/material';
import {
    HeadingWithBadgeComponent,
    RESPONSE_TIME_LIMIT_IN_MILLISECONDS,
    StatusMessageComponent,
    StatusType,
    styles,
    SUCCESS_CODE,
} from './system-status-card-helper';

export const SystemStatusCard = (): React.JSX.Element => {
    const {
        data: serverStatusResponse,
        isFetched: serverStatusFetched,
        isError: serverStatusError,
    } = useServerStatus();
    const {
        data: serverDataStatusResponse,
        isFetched: serverDataStatusFetched,
        isError: serverDataStatusError,
    } = useServerDataStatus();
    const [serverStatus, setServerStatus] = useState<StatusType | null>(null);
    const [dataStatus, setDataStatus] = useState<StatusType | null>(null);

    useEffect(() => {
        if (serverStatusError) {
            setServerStatus('error');
        } else if (serverStatusResponse && serverStatusFetched) {
            const { status, data } = serverStatusResponse;
            const responseTime: number = data?.responseTime ?? 0;

            if (status === SUCCESS_CODE) {
                setServerStatus(
                    responseTime <= RESPONSE_TIME_LIMIT_IN_MILLISECONDS
                        ? 'success'
                        : 'warning'
                );
            } else {
                setServerStatus('error');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serverStatusResponse, serverStatusError, serverStatusFetched]);

    useEffect(() => {
        if (serverDataStatusError) {
            setDataStatus('error');
        } else if (serverDataStatusResponse && serverDataStatusFetched) {
            const { status, data } = serverDataStatusResponse;

            // this could be UP, SLOW, or empty in case is missing.
            const sdzStatus = data?.sdzStatus ?? '';

            if (status === SUCCESS_CODE) {
                setDataStatus(sdzStatus !== 'UP' ? 'warning' : 'success');
            } else {
                setDataStatus('error');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        serverDataStatusResponse,
        serverDataStatusError,
        serverDataStatusFetched,
    ]);

    return (
        <InfoCard title={'Uptime Status'}>
            {serverStatusFetched || serverDataStatusFetched ? (
                <>
                    <Grid>
                        <HeadingWithBadgeComponent
                            title='Compute Network'
                            status={serverStatus}
                        />
                        <StatusMessageComponent
                            status={serverStatus}
                            enhanceWarning
                        />
                    </Grid>
                    <Grid mt={'9px'}>
                        <HeadingWithBadgeComponent
                            title='Storage Network'
                            status={dataStatus}
                        />
                        <StatusMessageComponent status={dataStatus} />
                    </Grid>
                </>
            ) : (
                <Grid sx={styles.loadingContainer}>
                    <CardLoader />
                </Grid>
            )}
        </InfoCard>
    );
};
